import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { faDeleteLeft, faEllipsisV, faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";

import CustomButton from "../../Components/CustomButton";
import CustomInput from "../../Components/CustomInput";
import CustomModal from "../../Components/CustomModal";
import CustomPagination from "../../Components/CustomPagination";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import CustomTable from "./../../Components/CustomTable";

import "./style.css";

import { placeholderImage } from "../../Assets/images";
import { useDeleteBannerMutation, useGetBannerQuery } from "../../Redux/Apis/Banner";
import { useUpdateBrandMutation } from "../../Redux/Apis/Brands";
import { dateFormatter } from "../../Utils";

const sortValues = [
    {
        text: "Name",
        value: "fullName",
    },
    {
        text: "Email",
        value: "email",
    }
];

const perPageValues = [
    {
        text: "8",
        value: 8,
    },
    {
        text: "15",
        value: 15,
    },
    {
        text: "30",
        value: 30,
    }
];

export const Banner = () => {

    const navigate = useNavigate()
    const [changeBrandStatus, { isLoading: isUpdating }] = useUpdateBrandMutation();

    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [showModal4, setShowModal4] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
    const [inputValue, setInputValue] = useState('');
    const [selectedBannerId, setSelectedBannerId] = useState();
    const [isFilterOpen, setIsFilterOpen] = useState(false);

    const [deleteModal, setDeleteModal] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);

    const [sortBy, setSortBy] = useState(sortValues[0].value);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");

    const { data, isLoading, refetch } = useGetBannerQuery({
        currentPage,
        itemsPerPage,
        role: "user",
        search: inputValue,
        sortBy,
        from,
        to
    });

    const [deleteBanner, { isLoading: isDeleting }] = useDeleteBannerMutation()

    const toggleFilter = () => setIsFilterOpen(!isFilterOpen)

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const inactiveMale = async () => {
        await changeBrandStatus({ id: selectedBannerId, payload: { active: false } })
        refetch()
        setSelectedBannerId()
        setShowModal(false)
        setShowModal2(true)
    }

    const activeMale = async () => {
        await changeBrandStatus({ id: selectedBannerId, payload: { active: true } })
        refetch()
        setSelectedBannerId()
        setShowModal3(false)
        setShowModal4(true)
    }

    const handleChange = (e) => {
        setInputValue(e.target.value);
    }

    const onDelete = async () => {
        await deleteBanner({ id: selectedBannerId })
        refetch()
        setSelectedBannerId()
        setDeleteModal(false)
        setConfirmDelete(true)
    }

    useEffect(() => {
        document.title = 'Landing List | Banner';
    }, []);

    const maleHeaders = [
        {
            key: "id",
            title: "S.No",
        },
        {
            key: "image",
            title: "Image",
        },
        {
            key: "type",
            title: "Type",
        },
        {
            key: "redirection",
            title: "URL",
        },
        {
            key: "registered",
            title: "Created On",
        },
        {
            key: "actions",
            title: "Actions",
        },
    ];

    return (
        <>
            <DashboardLayout>
                <div className="container-fluid">
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="dashCard">
                                <div className="row mb-3 justify-content-between">
                                    <div className="col-md-6 mb-2">
                                        <h2 className="mainTitle">Banner</h2>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <div className="addUser">
                                            {/* <CustomButton type="button" text="Add User" className="primaryButton" /> */}
                                            <CustomButton type="button" icon={faFilter} className="primaryButton rounded-50" onClick={toggleFilter} />
                                            <CustomInput type="text" placeholder="Search Here..." value={inputValue} inputClass="mainInput" onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    {
                                        isLoading ? <Loader /> :
                                            <div className="col-12">
                                                <CustomTable
                                                    headers={maleHeaders}
                                                    isFilterOpen={isFilterOpen}
                                                    dateFilter={false}
                                                    filterSort={true}
                                                    perPage={true}
                                                    filterSortValues={sortValues}
                                                    perPageValues={perPageValues}
                                                    filterSortValue={sortBy}
                                                    setFilterSortValue={setSortBy}
                                                    filterFrom={from}
                                                    setFilterFrom={setFrom}
                                                    filterTo={to}
                                                    setFilterTo={setTo}
                                                    itemsPerPage={itemsPerPage}
                                                    setItemsPerPage={setItemsPerPage}
                                                    length={data?.data?.length}
                                                    buttonLabel="Add Banner"
                                                    onClickButton={() => navigate('/add-banner')}
                                                >
                                                    <tbody>
                                                        {data?.data?.map((item, index) => (
                                                            <tr key={item._id}>
                                                                <td>{(index + 1) + ((currentPage - 1) * itemsPerPage)}</td>
                                                                <td className="text-capitalize">
                                                                    <img
                                                                        // src={item.image ? `${item?.image}` : placeholderImage}
                                                                        src={item.image ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${item?.image}` : placeholderImage}
                                                                        className="thumbnail"
                                                                    />
                                                                    {item.name}
                                                                </td>
                                                                <td>{item?.type}</td>
                                                                <td>{item?.redirection}</td>
                                                                <td>{dateFormatter(item.createdAt)}</td>
                                                                <td>
                                                                    <Dropdown className="tableDropdown">
                                                                        <Dropdown.Toggle variant="transparent" className="notButton classicToggle">
                                                                            <FontAwesomeIcon icon={faEllipsisV} />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu align="end" className="tableDropdownMenu">
                                                                            {/* <Link to={`/badges/user-details/${item._id}`} className="tableAction"><FontAwesomeIcon icon={faEye} className="tableActionIcon" />View</Link> */}
                                                                            <button onClick={() => {
                                                                                setSelectedBannerId(item._id)
                                                                                setDeleteModal(true)
                                                                            }} className="tableAction"><FontAwesomeIcon icon={faDeleteLeft} className="tableActionIcon" /> Delete</button>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </CustomTable>
                                                <CustomPagination
                                                    length={data?.data?.length}
                                                    itemsPerPage={itemsPerPage}
                                                    totalItems={data?.total}
                                                    currentPage={currentPage}
                                                    onPageChange={handlePageChange}
                                                />
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <CustomModal loading={isDeleting} show={deleteModal} close={() => { setDeleteModal(false) }} action={onDelete} heading='Are you sure you want to delete this banner?' />
                    <CustomModal show={confirmDelete} close={() => { setConfirmDelete(false) }} success heading='Brand Deleted Successfully' />
                </div>
            </DashboardLayout>
        </>
    );
};
